import { v4 as uuidv4 } from "uuid";
import { defaultData as defaultBlockDefaultData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/DefaultBlock/DefaultBlockDefaultData";
import { defaultData as footerBlockDefaultData } from "@/react/components/shared/Emails/VisualEmailBuilder/Blocks/Content/FooterBlock/FooterBlockDefaultData";
import type { RootBlock } from "@circle-react-shared/BuilderUI/DataModel.types";

export const defaultData: RootBlock = {
  id: uuidv4(),
  type: "root",
  props: {
    children: {
      prop: "children",
      type: "children",
      value: [defaultBlockDefaultData, footerBlockDefaultData],
    },
  },
};
